import React from "react";
import { Modal, Card, Divider, Space } from "antd";
import { neutral, spacing, radius, shadow, border } from "../../theme/tokens";

/**
 * Wrapper form: Modal hoặc full-page Card.
 * Enterprise-tone: không border-top accent, shadow gần như không có.
 */
export default function FormShell({
  asPage = false,
  title,
  open = true,
  footer,
  onCancel,
  width,
  styles,
  children,
}) {
  if (!asPage) {
    return (
      <Modal
        title={title}
        open={open}
        footer={footer}
        onCancel={onCancel}
        width={width}
        styles={styles}
      >
        {children}
      </Modal>
    );
  }

  return (
    <div
      style={{
        padding: `${spacing[6]}px ${spacing[6]}px ${spacing[8]}px`,
        backgroundColor: neutral[50],
        minHeight: "100vh",
      }}
    >
      <Card
        title={title}
        style={{
          borderRadius: radius.md,
          boxShadow: shadow.xs,
          border: border.hairline,
        }}
      >
        {children}
        {footer && (
          <>
            <Divider style={{ margin: `${spacing[6]}px 0 ${spacing[4]}px` }} />
            <Space style={{ width: "100%", justifyContent: "flex-end" }} size={spacing[3]}>
              {footer}
            </Space>
          </>
        )}
      </Card>
    </div>
  );
}
